import lazysizes from 'expose-loader?lazysizes!../../../libs/lazysizes/lazysizes';

import 'script-loader!../../../libs/lazysizes/plugins/respimg/ls.respimg.min.js'
import 'script-loader!../../../libs/lazysizes/plugins/parent-fit/ls.parent-fit.min.js'
import 'script-loader!../../../libs/lazysizes/plugins/bgset/ls.bgset.min.js'

export default lazysizes



// WEBPACK FOOTER //
// ./public/assets/js/src/vendor/lazysizes.js